export const CRMInvoice = [
    {
        "invoice_no": "INV-2025/1377",
        "amount": "Rs.8,850.00",
        "total_tax": "Rs.1,350.00",
        "date": "21/03/2025",
        "customer": "Gayathri Milk Dairy Pvt Ltd",
        "project": "suvarnna",
        "tags": ["invoice", "payment"],
        "due_date": "28/03/2025",
        "status": "Paid"
    },
    {
        "invoice_no": "INV-2025/1374",
        "amount": "Rs.41,064.00",
        "total_tax": "Rs.6,264.00",
        "date": "20/03/2025",
        "customer": "Vijay Sai Enterprises",
        "project": "gayatri project",
        "tags": ["invoice", "payment"],
        "due_date": "27/03/2025",
        "status": "Unpaid"
    },
    {
        "invoice_no": "INV-2025/1373",
        "amount": "Rs.9,794.00",
        "total_tax": "Rs.1,494.00",
        "date": "20/03/2025",
        "customer": "Baker's Mahal",
        "project": "ruchitha",
        "tags": ["invoice", "payment"],
        "due_date": "27/03/2025",
        "status": "Unpaid"
    },
    {
        "invoice_no": "INV-2025/1372",
        "amount": "Rs.2,360.00",
        "total_tax": "Rs.360.00",
        "date": "17/03/2025",
        "customer": "Tomatoes Super Market (Sai Manikanta)",
        "project": "pragathi",
        "tags": ["invoice", "payment"],
        "due_date": "24/03/2025",
        "status": "Unpaid"
    }
]
